import { useNavigate } from "react-router";
import { useAppSelector } from "../../../app/hooks";
import { Whatson } from "../whatsonSlice";
import { useAuth } from "react-oidc-context";

export const WhatsonListTools = () => {
  const navigate = useNavigate();
  const whatsonstate = useAppSelector(state => state.whatsonstate);
  const whatsons: Whatson[] = whatsonstate.whatsons;
  const auth = useAuth();

  const handleAdd = async () => {
    // need to pass the order value to the add/edit

    setTimeout(() => {
      // cant think of a way to ensure that the state has changed before calling the navigate
      // hence this hack
      navigate(`/schedule-add`);
    }, 1000)

  }

  return (
    <div className="padded-spread-container lr-padded-container">
      { auth.isAuthenticated && (
        <button
          type='button'
          className='btn'
          style={{marginLeft: '0.5rem'}}
          onClick={() => handleAdd()}
        >
          Add
        </button> 
      )}
      
      <div className="default-container" style={{display: 'none'}}>
        {whatsons.length === 0 ? 'No events to display...' : whatsons.length > 1 ? whatsons.length + ' events found' : '1 event found'}
      </div>
      <div className="default-container"></div>
      <div className="default-container">
      {/* filtering and sorting */}

      </div>
    </div>

  );
}